import { render, staticRenderFns } from "./ProvisionVatModal.vue?vue&type=template&id=cc6504b0&"
import script from "./ProvisionVatModal.vue?vue&type=script&lang=ts&"
export * from "./ProvisionVatModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports